"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveLocationStore = void 0;
const live_location_payload_1 = require("./types/live-location-payload");
/**
 * The store for live location data.
 */
// export type LiveLocationStore = Map<[string, string], LiveLocationUser>
class LiveLocationStore {
    /**
     * The locations stored in the store, indexed by a key generated from the organisation and user identifiers.
     */
    locations;
    constructor() {
        this.locations = new Map();
    }
    /**
     * Merges a live location payload into the store, indexed by user and organisation.
     *
     * If the payload is invalid or old, an error is thrown.
     * @param payload The payload to merge.
     * @param userId The user identifier.
     * @param organisationId The organisation identifier.
     * @returns The live location that was merged into the store.
     */
    mergePayload(payload, userId, organisationId) {
        // Validate the payload. Throws an error if unsuccessful.
        const result = live_location_payload_1.LiveLocationPayloadSchema.parse(payload);
        // Create a user object from the payload.
        const timestamp = Date.now();
        const location = {
            lng: payload.lngLat.lng,
            lat: payload.lngLat.lat,
        };
        const newLiveLocation = {
            lngLat: location,
            timestamp,
            staleTimestamp: payload.staleTimestamp,
        };
        // Get the organisation map from the store.
        const organisationMap = this.locations.get(organisationId);
        // If the organisation map does not exist, create it.
        if (organisationMap === undefined) {
            const newOrganisationMap = new Map();
            newOrganisationMap.set(userId, newLiveLocation);
            this.locations.set(organisationId, newOrganisationMap);
            return newLiveLocation;
        }
        // Get the existing live location for the user.
        const existingLiveLocation = organisationMap.get(userId);
        // Throw an error if the payload is older than the existing live location.
        if (existingLiveLocation && existingLiveLocation.timestamp >= timestamp)
            throw new Error(`Payload found to be older than existing records.`);
        // Update the live location in the store.
        organisationMap.set(userId, newLiveLocation);
        return newLiveLocation;
    }
    /**
     * Removes all live locations that are stale.
     * @returns The number of live locations that were removed.
     */
    removeStaleLocations() {
        const now = Date.now();
        let count = 0;
        for (const organisationMap of this.locations.values()) {
            for (const [userId, liveLocation] of organisationMap.entries()) {
                if (liveLocation.staleTimestamp <= now) {
                    organisationMap.delete(userId);
                    count++;
                }
            }
        }
        return count;
    }
}
exports.LiveLocationStore = LiveLocationStore;
